<template>
  
  <div v-if="!isLoading">

        <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <!-- Card stats -->
      <b-row>
        <b-col xl="4" md="6">
            <stats-card title="Nombre del Buque"
                        type="gradient-red"
                        :sub-title="BuquesFechas.length > 0 ? BuquesFechas[0].BUQUE_DE_DESCARGA : '-'"
                        icon="fas fa-ship"
                        class="mb-4">
            </stats-card>
          </b-col>

          <b-col xl="4" md="6">
            <stats-card title="Agente Naviero"
                        type="gradient-orange"
                        :sub-title="BuquesFechas.length > 0 ? BuquesFechas[0].AGENTE_NAVIERO : '-'"
                        icon="fas fa-anchor"
                        class="mb-4">
            </stats-card>
          </b-col>

        <b-col xl="4" md="6">
          <stats-card title="Puerto"
                      type="gradient-green"
                      :sub-title="BuquesFechas.length > 0 ? BuquesFechas[0].PUERTO : '-'"
                      icon="fas fa-industry"
                      class="mb-4">
          </stats-card>
        </b-col>
        <b-col xl="4" md="6">
          <stats-card title="Fecha de Arribo"
                      type="gradient-red"
                      :sub-title="BuquesFechas.length > 0 ? BuquesFechas[0].FECHA_ARRIBO : '-'"
                      icon="ni ni-calendar-grid-58"
                      class="mb-4">
          </stats-card>
        </b-col>
        <b-col xl="4" md="6">
          <stats-card title="Fecha de Atraque"
                      type="gradient-orange"
                      :sub-title="BuquesFechas.length > 0 ? BuquesFechas[0].FECHA_ATRAQUE : '-'"
                      icon="ni ni-calendar-grid-58"
                      class="mb-4">
          </stats-card>
        </b-col>
        <b-col xl="4" md="6">
          <stats-card title="Fecha de fin Operaciones"
                      type="gradient-green"
                      :sub-title="BuquesFechas.length > 0 ? BuquesFechas[0].FIN_DE_OPERACIONES : '-'"
                      icon="ni ni-calendar-grid-58"
                      class="mb-4">
          </stats-card>
        </b-col>
          <b-col xl="4" md="6">
            <stats-card title="Cantidad Total de Viajes"
            type="gradient-red"
            :sub-title="ContadorDeViajes.toString()"
            icon="ni ni-send"
            class="mb-4">
            <!-- :sub-title="$route.name" -->
            
            <!-- <template slot="footer">
              <span class="text-success mr-2">3.48%</span>
              <span class="text-nowrap">Rate de Viajes?</span>
            </template> -->
          </stats-card>
        </b-col>
        <b-col xl="4" md="6">
          <stats-card title="Cantidad total de Camiones"
          type="gradient-orange"
          :sub-title="Camiones.toString()"
          icon="fas fa-truck"
          class="mb-4">
          
          <!-- <template slot="footer">
            <span class="text-success mr-2">12.18%</span>
            <span class="text-nowrap">Rate de Camiones?</span>
          </template> -->
        </stats-card>
      </b-col>
    <b-col xl="4" md="6">
      <stats-card title="Estado"
                  type="gradient-info"
                  :sub-title="BuquesFechas.length > 0 ? BuquesFechas[0].ESTATUS : '-'"
                  icon="fas fa-signal"
                  class="mb-4">
      </stats-card>
    </b-col>
  </b-row>

    </base-header>


    <!--Charts-->
    <b-container fluid class="mt--7">
      <b-row class="mt-5">
        <b-col xl="9" class="mb-5 mb-xl-0">
          <page-visits-table :listaDatosData="listaDatosData"
                             :listaDatos="listaDatos"
                             :listaDatosProducto="listaDatosProducto"
                             :listaConsignave="listaConsignave"
                             :listaClientesNave="listaClientesNave"
                             :DataCompleta="DataCompleta"
          ></page-visits-table>
        </b-col>
        <b-col xl="3" class="mb-5 mb-xl-0">
          <card header-classes="bg-transparent">
          <b-row align-v="center" slot="header">
          <b-col>
            <!-- <h6 class="text-uppercase text-muted ls-1 mb-1">Performance</h6> -->
            <h5 class="h3 mb-0">Descarga en Balanza</h5>
          </b-col>
        </b-row>
        <!-- Pasa los datos y opciones al componente PieChart -->
        <pie-chart :chart-data="manifestadoVsDescargadoPieData" :extra-options="pieChartOptions3" />
        <!-- <bar-chart :chart-data="computedPieChartData" :extra-options="pieChartOptions2" /> -->
      </card>
       </b-col>
      </b-row>
      <b-row class="mt-5">
        <b-col xl="12" class="mb-5 mb-xl-0">
          <almacen-visits-table :listaDatosAlmacenDistribucion="listaDatosAlmacenDistribucion"
                                :listaDatos="listaDatos"
                                :listaDatosProducto="listaDatosProducto"
                                :listaConsignave="listaConsignave"
                                :listaClientesNave="listaClientesNave"
                                :listaDatosData="listaDatosData"
                                :ListaAlmacenes="ListaAlmacenes"
          ></almacen-visits-table>
        </b-col>

      </b-row>
      <b-row class="mt-5">
        <b-col xl="12" class="mb-5 mb-xl-0">
      <card header-classes="bg-transparent">
          <b-row align-v="center" slot="header">
          <b-col>
            <!-- <h6 class="text-uppercase text-muted ls-1 mb-1">Performance</h6> -->
            <h5 class="h3 mb-0">Descarga en Almacén</h5>
          </b-col>
        </b-row>

        <!-- Pasa los datos y opciones al componente PieChart -->
        <bar-chart :chart-data="computedBarChartData" :extra-options="pieChartOptions" />
      </card>
       </b-col>
      </b-row>

      <br>

      <b-row>
        <b-col xl="12" class="mb-5 mb-xl-0">
            
            <social-traffic-table :listaJornada="listaJornada"
                                  :listaDatosData="listaDatosData"
          ></social-traffic-table>

        </b-col>


      </b-row>
      <br>
      <b-row>
        <b-col xl="12" class="mb-5 mb-xl-0">
          <card header-classes="bg-transparent">
            <b-row align-v="center" slot="header">
              <b-col>
                <!-- <h6 class="text-uppercase text-muted ls-1 mb-1">Performance</h6> -->
                <h5 class="h3 mb-0">Descarga por Jornada</h5>
              </b-col>
            </b-row>

            <line-chart
              :height="800"
              :chart-data="computedLineChartData"
              :extra-options="BarChartLinea"
            >
            <!-- ref="bigChart" -->

            <!-- :extra-options="lineChartOptions" -->

            </line-chart>

          </card>
        </b-col>

      </b-row>

      <br>
      <b-row>
        <b-col xl="12" class="mb-5 mb-xl-0">
            
          <paralizaciones-table :listaJornada="listaJornada"
          :listaParalizacion="listaParalizacion"
          ></paralizaciones-table>


        </b-col>

        <!-- <b-col xl="5" class="mb-5 mb-xl-0">
            <camiones-table :listaJornada="listaJornada"
                                  :listaDatosData="listaDatosData"
          ></camiones-table>

        </b-col> -->

      </b-row>
      <br>

      <template>
  <div>
    <!-- Asegúrate de que el ref abarque todo el contenido que quieres capturar -->
    <div ref="ChartCamionesXViajes">
      <b-row class="mt-5">
        <b-col xl="12" class="mb-5 mb-xl-0">
          <card header-classes="bg-transparent">
            <b-row align-v="center" slot="header">
              <button @click="captureChartCamionesXViajes" class="btn btn-primary btn-sm">Crear Imagen</button>
              <b-col class="text-center">
                <!-- Colocar la imagen directamente en el encabezado para asegurar que se incluya en la captura -->
                <img src="/img/brand/a&g2.png" style="width: 10%;" alt="A&G Logo" class="chart-logo">
              </b-col>
            </b-row>
            <bar-chart  :chart-data="computedBarChartDataTransporte" :extra-options="pieChartOptions4" />
          </card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

      <template>
  <div>
    <!-- Asegúrate de que el ref abarque todo el contenido que quieres capturar -->
    <div ref="ChartPesoXTransporte">
      <b-row class="mt-5">
        <b-col xl="12" class="mb-5 mb-xl-0">
          <card header-classes="bg-transparent">
            <b-row align-v="center" slot="header">
              <button @click="captureChart" class="btn btn-primary btn-sm">Crear Imagen </button>
              <b-col class="text-center">
                <!-- Colocar la imagen directamente en el encabezado para asegurar que se incluya en la captura -->
                <img src="/img/brand/a&g2.png" style="width: 10%;" alt="A&G Logo" class="chart-logo">
              </b-col>
            </b-row>
            <horizontal-bar-chart
              v-if="datosListos && computedBarChartDataTransporteJORNADA.datasets.length > 0"
              :chart-data="computedBarChartDataTransporteJORNADA"
              :extra-options="HorizontalOpciones"
              :height="800"

            />
          </card>
        </b-col>
      </b-row>
    </div>
  </div>

</template>




    </b-container>

  </div>
  <div v-else>
    <!-- Puedes colocar un indicador de carga aquí, como un spinner o un mensaje -->
    Cargando datos...
  </div>
</template>
<script>
  // Charts
  import * as chartConfigs from '@/components/Charts/config';
  import ChartDataLabels from 'chartjs-plugin-datalabels';
import LineChart from '@/components/Charts/LineChart';
import BarChart from '@/components/Charts/BarChart';
import PieChart from '@/components/Charts/PieChart'; 
import HorizontalBarChart from '@/components/Charts/HorizontalBarChart'; 

import axios from 'axios';

  // Components
  import BaseProgress from '@/components/BaseProgress';
  import StatsCard from '@/components/Cards/StatsCard';

  // Tables
  import SocialTrafficTable from './Dashboard/SocialTrafficTable';
  import ParalizacionesTable from './Dashboard/ParalizacionesTable';
  import PageVisitsTable from './Dashboard/PageVisitsTable';
  import AlmacenVisitsTable from './Dashboard/AlmacenVisitsTable';
  import CamionesTable from './Dashboard/CamionesTable';
  import html2canvas from 'html2canvas';

  Chart.plugins.register(ChartDataLabels); // Esto está bien si quieres que se aplique globalmente

  export default {
    components: {
      HorizontalBarChart,
      LineChart,
      BarChart,
      PieChart, 
      BaseProgress,
      StatsCard,
      ParalizacionesTable,
      PageVisitsTable,
      CamionesTable, 
      SocialTrafficTable,
      AlmacenVisitsTable
    },
    data() {
      return {
        datosListos: false,
      isLoading: true,
        pieChartData: {
      labels: [],
      datasets: [{
        backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'],
        data: [],
      }],
    },

    chartData: {
        labels: ['Enero', 'Febrero', 'Marzo', 'Abril'],
        datasets: [
          {
            label: 'Dataset 1',
            backgroundColor: '#FF6384',
            stack: 'stack 0',  // Asegúrate de especificar un stack común para apilar
            data: [10, 20, 30, 40]
          },
          {
            label: 'Dataset 2',
            backgroundColor: '#36A2EB',
            stack: 'stack 0',  // Mismo ID de stack para apilar con el dataset anterior
            data: [20, 30, 40, 50]
          }
        ]
      },

  
  

    barChartOptions: {
      responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            stacked: true, // Importante para apilar los datos horizontalmente
          }],
          yAxes: [{
            stacked: true  // Importante para apilar los datos verticalmente
          }]
        },
        plugins: {
          datalabels: {
            anchor: 'end',
            align: 'top',
            formatter: (value, ctx) => {
              const datasets = ctx.chart.data.datasets;
              if (ctx.datasetIndex === datasets.length - 1) {
                let sum = 0;
                datasets.map(dataset => {
                  sum += dataset.data[ctx.dataIndex];
                });
                return sum;
              } else {
                return "";
              }
            },
            color: '#000',
          }
        }
      },
  

    BarChartLinea: {
      responsive: true,
  maintainAspectRatio: false,
  legend: {
    display: true,
    position: 'bottom',
    labels: {
      fontColor: '#333',
    },
  },
  scales: {
    xAxes: [{
      ticks: {
        beginAtZero: true,
        fontColor: '#333',
        fontSize: 12,
        autoSkip: true,
        maxRotation: 0,
        minRotation: 0,
      },
      gridLines: {
        display: false,
      },
    }],
    yAxes: [{
      ticks: {
        beginAtZero: true,
        fontColor: '#333',
        fontSize: 11,
      },
      gridLines: {
        display: true,
      },
    }],
  },
  elements: {
    line: {
      borderWidth: 1,
    },
  },
  plugins: {
    datalabels: {
      color: '#444',
      font: {
        size: 11,
      },
      formatter: function(value, context) {
        // Podría personalizarse aún más si se requiere
        return value;
      }
    }
  },
},

 pieChartOptions: {
  responsive: true,
  maintainAspectRatio: false,
  legend: {
    display: true,
    position: 'bottom',
    labels: {
      fontColor: '#333',
    },
  },
  scales: {
    xAxes: [{
      barThickness: 75, // Establece el grosor de las barras
      maxBarThickness: 75, // Limita el grosor máximo de las barras
      categoryPercentage: 0.5, // Controla el espacio entre categorías (grupos de barras)
      barPercentage: 0.5, // Reduce para incrementar el espacio entre las barras dentro de una categoría
      ticks: {
        beginAtZero: true,
        fontColor: '#333',
        fontSize: 12,
        autoSkip: true,
        maxRotation: 0, // Rota las etiquetas hasta 90 grados
        minRotation: 0, // Rotación mínima de 45 grados
          },
      gridLines: {
        display: true,
      },
    }],
    yAxes: [{
      barThickness: 75, // Establece el grosor de las barras
      maxBarThickness: 75, // Limita el grosor máximo de las barras
      categoryPercentage: 1, // Controla el espacio entre categorías (grupos de barras)
      barPercentage: 1, // 
      ticks: {
        beginAtZero: true,
        fontColor: '#333',
        fontSize: 11,
      },
      gridLines: {
        display: true,
      },
    }],
  },
  elements: {
    rectangle: {
      borderWidth: 1,
    },
  },
  layout: {
    padding: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
    },
  },
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
        datalabels: {
          color: '#444', // Color del texto de las etiquetas
          anchor: 'center',
          size: '12px',
          align: 'center',
          formatter: function(value, context) {
            return value; // Muestra el valor de la barra como etiqueta
          }
        }
      },
},

// HorizontalOpciones() {
//     return {
//       responsive: true,
//       maintainAspectRatio: false,
//       scales: {
//         xAxes: [{
//           ticks: {
//             beginAtZero: true
//           }
//         }],
//         yAxes: [{
//           ticks: {
//             beginAtZero: true
//           }
//         }]
//       },
//       plugins: {
//         datalabels: {
//           color: '#444',
//           anchor: 'end',
//           align: 'top',
//           font: {
//             size: 14
//           },
//           formatter: function(value) {
//             return value > 0 ? value : "";
//           }
//         }
//       }
//     };
//   },



pieChartOptions3: {
  responsive: true,
  maintainAspectRatio: false,
  legend: {
    display: true,
    position: 'bottom',
    labels: {
      fontColor: '#333',
    },
  },
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
        datalabels: {
          color: '#444', // Color del texto de las etiquetas
          anchor: 'end',
          align: 'top',
          formatter: function(value, context) {
            return value; // Muestra el valor de la barra como etiqueta
          }
        }
      },
},

pieChartOptions2: {
  responsive: true,
  maintainAspectRatio: false,
  legend: {
    display: true,
    position: 'bottom',
    labels: {
      fontColor: '#333',
    },
  },
  scales: {
    xAxes: [{
      barThickness: 30, // Controla el grosor de las barras.
      maxBarThickness: 30, // Limita el grosor máximo de las barras.
      categoryPercentage: 0.6, // Reduce este valor para aumentar el espacio entre las categorías/barras.
      barPercentage: 0.95, // Controla el ancho de las barras dentro de su categoría.
      ticks: {
        beginAtZero: true,
        fontColor: '#333',
        fontSize: 10,
      },
      gridLines: {
        display: true,
      },
    }],
    yAxes: [{
      ticks: {
        beginAtZero: true,
        fontColor: '#333',
        fontSize: 11,
      },
      gridLines: {
        display: true,
      },
    }],
  },
  elements: {
    rectangle: {
      borderWidth: 2,
    },
  },
  layout: {
    padding: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
    },
  },
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
        datalabels: {
          color: '#444', // Color del texto de las etiquetas
          anchor: 'end',
          align: 'top',
          formatter: function(value, context) {
            return value; // Muestra el valor de la barra como etiqueta
          }
        }
      },
},


pieChartOptions4: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          fontColor: '#333',
        }
      },
      scales: {
        xAxes: [{
          barThickness: 40,
          maxBarThickness: 30,
          categoryPercentage: 0.6,
          barPercentage: 0.95,
          ticks: {
            beginAtZero: true,
            fontColor: '#333',
            fontSize: 9,
            autoSkip: false,
            callback: value => this.adjustLabels(value),

          },
          gridLines: {
            display: true,
          },
        }],
        yAxes: [{
          id: 'y-axis-1',
          type: 'linear',
          position: 'left',
          max: 50, // Max visual value for bars
          ticks: {
            beginAtZero: true,
          },
        }, {
          id: 'y-axis-2',
          type: 'linear',
          position: 'right',
          max: 7, // Max visual value for the line
          ticks: {
            beginAtZero: true,
            suggestedMax: 7,
          },
          gridLines: {
            drawOnChartArea: false, // No grid lines for the second y-axis
          },
        }]
      },
      plugins: {
        datalabels: {
          color: '#444',  // Text color of the labels
          anchor: 'end',
          align: 'top',
          formatter: function(value, context) {
            return value;  // Displays the value of the bar as a label
          }
        }
      },
    },




bigLineChart: {
  activeIndex: 0,
  chartData: {
    datasets: [
      {
        label: 'Line 1',
        data: [10, 20, 10, 30, 15, 40, 20, 60, 60],
        borderColor: 'rgba(75, 192, 192, 1)',
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
      },
      {
        label: 'Line 2',
        data: [30, 20, 5, 25, 10, 30, 15, 40, 40],
        borderColor: 'rgba(255, 99, 132, 1)',
        backgroundColor: 'rgba(255, 99, 132, 0.2)',
      },
    ],
    labels: [], // Initialize labels as an empty array
  },
  extraOptions: {
  scales: {
    y: {
      beginAtZero: true,
      stepSize: 10, // Tamaño de paso
    },
  },
  responsive: true,
  maintainAspectRatio: false,
  elements: {
    line: {
      tension: 0, // Ajusta la tensión de la línea
    },
  },
  plugins: {
    legend: {
      display: true,
      position: 'bottom',
      labels: {
        fontColor: '#333',
      },
    },
  },
},

},

        listaDatosData: [],
        listaDatos: [],
        listaDatosProducto: [],
        listaConsignave:[],
        listaClientesNave:[],
        listaDatosAlmacenDistribucion: [],
        ListaAlmacenes:[],
        listaJornada:[],
        listaNaves: [],
        listaParalizacion: [],
        listaSilos:[]
      };
    },

    created(){
      this.cargarTodosLosDatos();

     },
     computed:{

      HorizontalOpciones() {
  return {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxes: [{
        barThickness: 50,
        maxBarThickness: 50,
        categoryPercentage: 0.2,
        barPercentage: 0.5,
        ticks: {
          beginAtZero: true,
          fontSize: 10,
   
        }
      }],
      yAxes: [{
        barThickness: 20,
        maxBarThickness: 20,
        categoryPercentage: 0.8,
        barPercentage: 0.5,
        ticks: {
          beginAtZero: true,
          fontSize: 11,

        }
      }]
    },
    plugins: {
      datalabels: {
        color: '#444',
        anchor: 'center',  // Anchor text to the center of the bar
        align: 'center',
        formatter: function(value, context) {
          const allData = context.chart.data.datasets[0].data; // Assumes single dataset
          const currentJornadaIndex = context.dataIndex;
          const currentJornadaValue = context.dataset.data[currentJornadaIndex];
          
          if (currentJornadaValue === 0) {
            // Check if this is the first occurrence of '0' in this jornada
            const firstZeroIndex = allData.indexOf(0);
            if (currentJornadaIndex === firstZeroIndex) {
              return '0';  // Only show '0' for the first instance in this jornada
            }
            return null;  // Do not show '0' for subsequent zeros
          } else {
            return value;
          }
        },
        font: {
          size: 10 // Size for the datalabels
        }
      }
    },
    legend: {
      display: true,
      position: 'bottom',
      labels: {
        fontSize: 12,
    },
    }
  };
},







      routeParams() {
      return this.$route.params;
    },

    // Utiliza la nueva propiedad calculada para obtener los parámetros
    ID_NAVE() {
      return this.routeParams.ID_NAVE || '';
    },

    ID_CONSIGNATARIO() {
      return this.routeParams.ID_CONSIGNATARIO || '';
    },

    BuquesFechas() {
    // Comprueba si listaNaves está definida y tiene elementos
    if (this.listaNaves && this.listaNaves.length > 0) {
      // Mapea los datos de listaNaves a la estructura deseada
      return this.listaNaves.map((item) => ({
        FECHA_ARRIBO: item.FECHA_ARRIBO,
        FECHA_ATRAQUE: item.FECHA_ATRAQUE,
        ESTATUS: item.ESTATUS,
        BUQUE_DE_DESCARGA: item.BUQUE_DE_DESCARGA,
        PUERTO: item.PUERTO,
        AGENTE_NAVIERO: item.AGENTE_NAVIERO,
        FIN_DE_OPERACIONES: item["FIN DE OPERACIONES"],
      }));
    } else {
      // Retorna un array vacío si listaNaves no está disponible o está vacía
      return [];
    }
  },


      AlmacenesDistribution() {
        return this.listaDatosAlmacenDistribucion.map((item) => {
          if (this.listaDatos && this.listaDatos.length > 0) {
            this.listaDatos.forEach(productosnave => {
              if (productosnave.ID == item.ID_PRODUCTO)
                item.PRODUCTO = productosnave.PRODUCTO
            });
          }

          if (this.ListaAlmacenes && this.ListaAlmacenes.length > 0) {
            this.ListaAlmacenes.forEach(almacen => {
              if (almacen.ID == item.ALMACEN)
                item.ALMACEN = almacen.ALMACEN
            });
          }

          return {
            CANTIDAD: this.convertir(item.CANTIDAD),
            PRODUCTO: item.PRODUCTO,
            ALMACEN: item.ALMACEN,
            ID_PRODUCTO: item.ID_PRODUCTO,
            ID: item.ID
          };
        });
      },

      AlmacenUnico() {
      let almacen = [  
         ...new Set(this.listaDatosAlmacenDistribucion.map(almacenlist => almacenlist.ID))
        ]
         return almacen
      },


      JornadaFiltrada() {
  return this.JornadaUnica
    .filter(idproductophite => this.ViajesBalanzaJornada(idproductophite) > 0)
    .map(idproductophite => idproductophite.toString());
},

JornadaUnica() {
  let jornada = [
    ...new Set(this.listaJornada.map((productlist) => productlist.ID))
  ];
  return jornada.map(id => id.toString());
},


      ContadorDeViajes() {
        return this.DataCompleta.length
      },

      computedLineChartData() {
  const labels = [];
  const dataLine1 = [];
  const dataLine2 = [];

  this.JornadaFiltrada.forEach(row => {
    const jornadaNumber = this.Jornada(row).split('N°')[1].trim();
    labels.push(`N° ${jornadaNumber}`);
    dataLine1.push(this.PnetoBalanzaJornada(row));
    dataLine2.push(this.PnetoAlmacenEnAlmacen(row));
  });

  return {
    labels,
    datasets: [
      {
        label: 'Balanza',
        backgroundColor: '#004D6B4D',
        borderColor: '#004D6B',
        data: dataLine1,
        datalabels: {
          anchor: 'end',
          align: 'end',
          offset: 4,
        }
      },
      {
        label: 'Almacén',
        backgroundColor: '#008B8B4D',
        borderColor: '#008B8B',
        data: dataLine2,
        datalabels: {
          anchor: 'start',
          align: 'start',
          offset: 4,
        }
      },
    ],
  };
},


        
        computedBarChartDataTransporteJORNADA() {
  if (!this.datosListos) return { labels: [], datasets: [] };

  const jornadasData = this.DataCompleta.filter(item => {
    const isIDValid = this.listaJornada.some(j => j.ID === item.JORNADA);
    const isAlmacenExcluded = item.ALMACEN === "REDONDOS - VENTA" || item.ALMACEN === "CERSUR";
    return isIDValid && !isAlmacenExcluded;
  });

  const transportes = [...new Set(jornadasData.map(item => item.TRANSPORTE))];
  const jornadas = [...new Set(jornadasData.map(item => {
    const jornadaItem = this.listaJornada.find(j => j.ID === item.JORNADA);
    return jornadaItem ? jornadaItem.JORNADA : null;
  }))].sort((a, b) => parseInt(a.replace("JORNADA N", "")) - parseInt(b.replace("JORNADA N", "")));

  let totalPorJornada = jornadas.map(jornada => jornadasData.reduce((acc, item) => {
    const jornadaItem = this.listaJornada.find(j => j.ID === item.JORNADA);
    return jornadaItem && jornadaItem.JORNADA === jornada ? acc + item.PESO_NETO_PUERTO : acc;
  }, 0).toFixed(3));

  const datasets = transportes.map((transporte, index) => {
    const color = this.getRandomColor(index);  // Use the index to get a consistent color
    const data = jornadas.map(jornada => {
      const sum = jornadasData.reduce((acc, item) => {
        const jornadaItem = this.listaJornada.find(j => j.ID === item.JORNADA);
        return item.TRANSPORTE === transporte && jornadaItem && jornadaItem.JORNADA === jornada ? acc + item.PESO_NETO_PUERTO : acc;
      }, 0);
      return parseFloat(sum.toFixed(3));
    });

    return {
      label: transporte,
      backgroundColor: color,
      data,
      stack: 'stack0'
    };
  }).filter(dataset => dataset.data.some(value => value !== 0));

  // Modified here to remove the word "JORNADA" from each label and format it as "N (TotalPorJornada kg)"
  const labels = jornadas.map((jornada, index) => {
    const jornadaNumber = jornada.replace("JORNADA ", "").trim();  // Remove the word "JORNADA N"
    return `${jornadaNumber} (${totalPorJornada[index]} TM)`;  // Format as "N (TotalPorJornada kg)"
  });

  return {
    labels: labels,
    datasets,
    $totalPorJornada: totalPorJornada
  };
},









computedBarChartDataTransporte() {
  // Primero, filtramos los elementos excluyendo los almacenes especificados
  const datosFiltrados = this.DataCompleta.filter(item => item.ALMACEN !== "REDONDOS - VENTA" && item.ALMACEN !== "CERSUR");

  // Usamos los datos filtrados para generar las etiquetas y calcular los datos de los gráficos
  const labels = [...new Set(datosFiltrados.map(item => item.TRANSPORTE))];
  const manifestadoData = [];
  const pnetoData = [];
  const lineaData = [];

  labels.forEach(transporte => {
    const filtradosPorTransporte = datosFiltrados.filter(item => item.TRANSPORTE === transporte);
    const totalPlacas = filtradosPorTransporte.length;
    const placasUnicas = new Set(filtradosPorTransporte.map(item => item.PLACA)).size;

    manifestadoData.push(totalPlacas);
    pnetoData.push(placasUnicas);
    lineaData.push(parseFloat((totalPlacas / placasUnicas).toFixed(2)));
  });

  return {
    labels,
    datasets: [
      {
        label: 'Total Viajes',
        backgroundColor: '#FFAF1D',
        data: manifestadoData,
      },
      {
        label: 'Total Camiones',
        backgroundColor: '#FF6800',
        data: pnetoData,
      },
      {
        label: 'Viajes x Camiones',
        type: 'line',
        borderColor: '#008B8B',
        borderWidth: 3,
        fill: false,
        data: lineaData,
        tension: 0.4, // Controla la curvatura de la línea
        yAxisID: 'y-axis-2', // Asocia este dataset con el segundo eje Y
        pointBackgroundColor: '#008B8B', // Color de los puntos
        pointRadius: 5, // Tamaño de los puntos
      },
    ],
  };
},

    

            computedBarChartData() {
          const labels = [];
          const manifestadoData = [];
          const pnetoData = [];
          const productoData = [];

          this.AlmacenUnico.forEach(row => {
            const nombreAlmacen = this.NombreAlmacen(row);
            const productoAlmacen = this.ProductoAlmacen(row);

            // Obtener iniciales del NombreAlmacen
            const initials = this.getInitials(productoAlmacen);

            // Crear etiquetas combinando iniciales, ProductoAlmacen y/o otros detalles necesarios
            labels.push(`${nombreAlmacen} - ${initials}`);

            // Agregar datos para Manifestado y PnetoBalanza
            manifestadoData.push(this.ManifestadoAlmacen(row));
            pnetoData.push(this.PnetoBalanzaEnAlmacen(row));
          });

          return {
            labels,
            datasets: [
              {
                label: 'Manifestado',
                backgroundColor: '#FFAF1D',
                data: manifestadoData,
              },
              {
                label: 'Descargado',
                backgroundColor: '#FF6800',
                data: pnetoData,
              },
            ],
          };
        },

      computedPsdaieChartData() {
    const labels = [];
    const data = [];

    this.ProductoUnico.forEach(row => {
      labels.push(this.Producto(row));
      data.push(this.PnetoBalanza(row));
    });

    return {
      labels,
      datasets: [{
        backgroundColor: ['#FFAF1D', '#FF6800', '#004D6B', '#008B8B', '#BEDBE1', '#001C26' ],
        data,
      }],
    };
  },

  manifestadoVsDescargadoPieData() {
  let totalManifestado = 0;
  let totalDescargado = 0;

  // Suma todos los valores de Manifestado y Descargado
  this.ProductoUnico.forEach(row => {
    totalManifestado += parseFloat(this.ManifestadoBalanza(row));
    totalDescargado += parseFloat(this.PnetoBalanza(row));
  });

  // Calcula la diferencia y asegura que solo tenga dos decimales
  let diferencia = totalManifestado - totalDescargado;
  let faltanteDescargar = parseFloat(diferencia.toFixed(3));

  // Prepara los datos para el gráfico de pastel
  return {
    labels: ['Descargado', 'Saldo'],
    datasets: [{
      data: [totalDescargado, faltanteDescargar], // Asegura dos decimales para la parte faltante
      backgroundColor: ['#001C26', '#BEDBE1'],
      hoverBackgroundColor: ['#001C26', '#BEDBE1']
    }]
  };
},


  computedPieChartData() {
          const labels = [];
          const manifestadoData = [];
          const pnetoData = [];
          const productoData = [];

          this.ProductoUnico.forEach(row => {
            const nombreAlmacen = this.Producto(row);
            const productoAlmacen = this.PnetoBalanza(row);

            // Obtener iniciales del NombreAlmacen
            const initials = this.getInitials(productoAlmacen);

            // Crear etiquetas combinando iniciales, ProductoAlmacen y/o otros detalles necesarios
            labels.push(`${nombreAlmacen}`);

            // Agregar datos para Manifestado y PnetoBalanza
            manifestadoData.push(this.ManifestadoBalanza(row));
            pnetoData.push(this.PnetoBalanza(row));
          });

          return {
            labels,
            datasets: [
              {
                label: 'Manifestado',
                backgroundColor: '#001C26',
                data: manifestadoData,
              },
              {
                label: 'Descargado',
                backgroundColor: '#BEDBE1',
                data: pnetoData,
              },
            ],
          };
        },



      Camiones() {
      let camiones = [  
         ...new Set(this.listaDatosData.map(listamarca => listamarca.PLACA))
        ]

        let este = camiones.filter(function(dato){
              return dato != undefined
            });
         return este.length
      },

      DataCompleta() {
        return this.listaDatosData.map((item) => {
          // Encontrar el correspondiente almacen basado en el ID_DIST_PRODUCTO_ALM
          const almacenInfo = this.listaDatosAlmacenDistribucion.find(alm => alm.ID === item.ID_DIST_PRODCUTO_ALM);
          
          return {
            PESO_NETO_PUERTO: this.convertir(item.PESO_NETO_PUERTO),
            PESO_NETO_ALMACEN: this.convertir(item.PESO_NETO_ALMCEN),
            ID_PRODUCTO: item.ID_PRODUCTO,
            TRANSPORTE: item.TRANSPORTE,
            ID_DIST_PRODCUTO_ALM: item.ID_DIST_PRODCUTO_ALM,
            FECHA_INICIO_CARGUIO: item.FECHA_INICIO_CARGUIO,
            FECHA_FIN_CARGIO: item.FECHA_FIN_CARGIO,
            JORNADA: item.JORNADA,
            PLACA: item.PLACA,
            ALMACEN: almacenInfo ? almacenInfo.ALMACEN : "Desconocido"  // Asignar el ALMACEN si se encuentra, sino "Desconocido"
            // PUERTO: item.ID_NAVES+'_'+item.CLIENTE
          };
        }).filter(element => element.ID_PRODUCTO !== undefined);
      },


        ProductoUnico() {
      let producto = [  
      ...new Set(this.listaDatos.map(productlist => productlist.ID))
      ]
      return producto
      },
      DataCompletaAlmacen() {
      return this.listaDatosData.map((item) => {
  
        return {
          
          PESO_NETO_ALMCEN: this.convertir(item.PESO_NETO_ALMCEN),
          FECHA_INGRESO_ALMACEN: item.FECHA_INGRESO_ALMACEN,
          PLACA: item.PLACA,
          ID_DIST_PRODCUTO_ALM: item.ID_DIST_PRODCUTO_ALM,
          JORNADA: item.JORNADA
          // PUERTO: item.ID_NAVES+'_'+item.CLIENTE
                };
            }).filter(function( element ) {
          return element.FECHA_INGRESO_ALMACEN !== undefined;
        }).filter(function( element ) {
          return element.FECHA_INGRESO_ALMACEN !== 0;
        })
      },
         


      mappedItems() {
  if (this.listaDatos && this.listaDatosProducto && this.listaConsignave && this.listaClientesNave) {
    return this.listaDatos.map((item) => {
      this.listaDatosProducto.forEach(product => {
        if (product.ID == item.PRODUCTO)
          item.PRODUCTO = product.PRODUCTO;
      });

      this.listaConsignave.forEach(productoxd => {
        if (productoxd.ID == item.ID_CONSIGNATARIO)
          item.CONSIGNAVE = productoxd.CONSIGNATARIO;
      });

      this.listaClientesNave.forEach(clientnave => {
        if (clientnave.ID == item.CONSIGNAVE)
          item.CONSIGNAVE = clientnave.CONSIGNATARIO;
      });

      return {
        BAGS: item.BAGS,
        BLS: item.BLS,
        CANTIDAD: this.convertir(item.CANTIDAD),
        PRODUCTO: item.PRODUCTO,
        ID: item.ID,
        Consignatario: item.CONSIGNAVE,
      };
    });
  } else {
    console.error('Al menos una de las listas es undefined. Lista de datos:', this.listaDatos, 'Lista de productos:',
     this.listaDatosProducto, 'Lista de consignatarios:', this.listaConsignave, 'Lista de clientes de nave:', this.listaClientesNave);
    return [];
  }
  },


  
      
     },
    methods: {

     
      captureChart() {
  const chartElement = this.$refs.ChartPesoXTransporte;

  if (!chartElement) {
    console.error('Error capturing chart: Chart element not found');
    return;
  }

  // Ocultar el botón 'Crear Imagen' temporalmente
  const captureButton = chartElement.querySelector('button');
  if (captureButton) {
    captureButton.style.display = 'none';
  }

  // Aumentar el factor de escala para mejorar la resolución de la imagen
  html2canvas(chartElement, {
    useCORS: true,
    scale: 2, // Aumenta este valor para mejorar la calidad
    onclone: (document) => {
      const imageElement = document.getElementById('chart-logo');
      if (imageElement) {
        // Mostrar la imagen durante la captura
        imageElement.style.display = 'inline';
      } else {
        console.warn('Image element not found in cloned document');
      }
    }
  }).then((canvas) => {
    // Restaurar la visualización del botón después de la captura
    if (captureButton) {
      captureButton.style.display = 'inline';
    }

    const imageElement = document.getElementById('chart-logo');
    if (imageElement) {
      imageElement.style.display = 'none';
    }

    // Convertir el canvas a un formato PNG de alta calidad
    const image = canvas.toDataURL("image/png", 1.0); // 1.0 especifica la calidad máxima
    const link = document.createElement('a');
    link.href = image;
    link.download = 'ChartPesoXTransporte_HD.png'; // Nombre de archivo con indicación HD
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }).catch(err => console.error('Error capturing chart:', err));
},


captureChartCamionesXViajes() {
  const chartElement = this.$refs.ChartCamionesXViajes;
  
  if (!chartElement) {
    console.error('Error capturing chart: Chart element not found');
    return;
  }

  // Ocultar el botón 'Crear Imagen' temporalmente
  const captureButton = chartElement.querySelector('button');
  if (captureButton) {
    captureButton.style.display = 'none';
  }

  // Aumentar el factor de escala para mejorar la resolución de la imagen
  html2canvas(chartElement, {
    useCORS: true,
    scale: 2, // Aumenta este valor para mejorar la calidad
    onclone: (document) => {
      const imageElement = document.getElementById('chart-logo');
      if (imageElement) {
        imageElement.style.display = 'inline';
      } else {
        console.warn('Image element not found in cloned document');
      }
    }
  }).then((canvas) => {
    // Restaurar la visualización del botón después de la captura
    if (captureButton) {
      captureButton.style.display = 'inline';
    }

    const imageElement = document.getElementById('chart-logo');
    if (imageElement) {
      imageElement.style.display = 'none';
    }

    // Convertir el canvas a un formato PNG de alta calidad
    const image = canvas.toDataURL("image/png", 1.0); // 1.0 especifica la calidad máxima
    const link = document.createElement('a');
    link.href = image;
    link.download = 'ChartCamionesXViajes_HD.png'; // Nombre de archivo con indicación HD
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }).catch(err => console.error('Error capturing chart:', err));
},




      PnetoBalanzaJornadaTransporte( transporte) {
    let totalPesoNeto = 0;
    let relevantItems = this.DataCompleta.filter(item => item.TRANSPORTE === transporte);
    relevantItems.forEach(item => {
      totalPesoNeto += Number(item.PESO_NETO_PUERTO);  // Asegúrate de convertir a Number si es necesario
    });
    return totalPesoNeto.toFixed(3);  // Devu
  },

  getRandomColor(index) {
  const colors = [
    '#4BC0C0', '#BEDBE1', '#FFAF1D', '#FF6800', '#008B8B', '#FF6384',
     '#BEDBE14D', '#FFAF1D4D', '#FF68004D', '#008B8B4D', '#FF63844D'
  ]; // Lista de colores disponibles con y sin opacidad

  return colors[index % colors.length];
},




    async cargarTodosLosDatos() {
      try {
        await Promise.all([
          this.getListaProducto(),
          this.getListaData(),
          this.getLista(),
          this.GetListaClienteNave(),
          this.GetListaJornada(),
          this.getListaAlmacenes(),
          this.getListaAlmacenesDistribucion(),
          this.getListaNave(),
          this.GetListaParalizacion(),

        ]);
        console.log("Todos los datos se han cargado con éxito");
        this.datosListos = true;
      } catch (error) {
        console.error("Error al cargar los datos: ", error);
        this.datosListos = false;
      } finally {
        this.isLoading = false;
      }
    },

    adjustLabels(label) {
    // Convierte 'label' a cadena si no lo es, para asegurar la compatibilidad
    const strLabel = String(label);
    const maxChar = 18;  // Máximo de caracteres antes de truncar y añadir puntos suspensivos

    // Verifica si la longitud de la etiqueta supera el máximo permitido
    if (strLabel.length > maxChar) {
      // Trunca la etiqueta y añade puntos suspensivos
      return strLabel.substring(0, maxChar) + '...';
    }

    // Devuelve la etiqueta sin modificar si no supera la longitud máxima
    return strLabel;
  },
//        initBigChart(index) {
//   let chartData = {
//     datasets: [
//       {
//         label: 'Performance 1',
//         data: this.bigLineChart.allData[index].map((value, i, arr) => ({
//           x: i === arr.length - 1 ? null : i,
//           y: value,
//         })),
//         pointBackgroundColor: 'rgba(75, 192, 192, 1)',
//         pointRadius: 5,
//         fill: false,
//       },
//       {
//         label: 'Performance 2',
//         data: this.redBarChart.chartData.datasets[0].data.map((value, i, arr) => ({
//           x: i === arr.length - 1 ? null : i,
//           y: value,
//         })),
//         pointBackgroundColor: 'rgba(255, 0, 0, 1)',
//         pointRadius: 5,
//         fill: false,
//       },
//     ],
//     labels: ['May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'as'],
//   };
//   this.bigLineChart.chartData = chartData;
//   this.bigLineChart.activeIndex = index;
// },

ManifestadoBalanza(idproductophite) {
      let pnetoTotal = 0
      let res =  this.mappedItems.filter(val => {
      return val.ID == idproductophite;
      })

      res.forEach(element => {
      pnetoTotal += element.CANTIDAD
      });

      return pnetoTotal.toFixed(3);

      },


formatDate(dateString) {
      // Implementa la lógica para formatear la fecha según tus necesidades
      // Puedes usar bibliotecas como moment.js o simplemente JavaScript puro.
      // Por ejemplo:
      const date = new Date(dateString);
      return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
    },

      getInitials(text) {
          return text
            .split(' ')
            .map(word => word.charAt(0).toUpperCase())
            .join('');
        },

    PnetoBalanzaEnAlmacen(idalmacenphite) {
         let pnetoTotal = 0
        let res =  this.DataCompleta.filter(val => {
            return val.ID_DIST_PRODCUTO_ALM == idalmacenphite;
        })

        res.forEach(element => {
          pnetoTotal += element.PESO_NETO_PUERTO
        });

      return pnetoTotal.toFixed(3);

      },

    NombreAlmacen(idalmacenphite) {
         let pnetoTotal = ''
        let res =  this.AlmacenesDistribution.filter(val => {
            return val.ID == idalmacenphite;
        })

        res.forEach(element => {
          pnetoTotal += element.ALMACEN
        });

      return pnetoTotal;

      },

      ProductoAlmacen(idalmacenphite) {
      let pnetoTotal = ''
      let res =  this.AlmacenesDistribution.filter(val => {
      return val.ID == idalmacenphite;
      })

      res.forEach(element => {
      pnetoTotal += element.PRODUCTO
      });

      return pnetoTotal;

      },

      ManifestadoAlmacen(idalmacenphite) {
         let pnetoTotal = 0
        let res =  this.AlmacenesDistribution.filter(val => {
            return val.ID == idalmacenphite;
        })

        res.forEach(element => {
          pnetoTotal += element.CANTIDAD
        });

      return pnetoTotal.toFixed(3);

      },


ViajesBalanzaJornada(idproductophite) {
        let res =  this.DataCompleta.filter(val => {
            return val.JORNADA == idproductophite != 0;
        }).filter(function( element ) {
        return element.PESO_NETO_PUERTO !== 0;
        })
         return res.length;
      },
  
      ViajesBalanza(idproductophite) {
          let res =  this.DataCompleta.filter(val => {
            return val.ID_PRODUCTO == idproductophite != 0;
          }).filter(function( element ) {
            return element.PESO_NETO_PUERTO !== 0;
          });
          return res.length;
        },

      Producto(row) {
        let pnetoTotal = ''
        let res =  this.mappedItems.filter(val => {
        return val.ID == row;
        })

        res.forEach(element => {
        pnetoTotal += element.PRODUCTO
        });

      return pnetoTotal;

      },

      Jornada(idproductophite) {
         let pnetoTotal = ''
        let res =  this.listaJornada.filter(val => {
            return val.ID == idproductophite;
        })

        res.forEach(element => {
          pnetoTotal += element.JORNADA
        });

      return pnetoTotal;

      },

      PnetoAlmacenEnAlmacen(idproductophite) {
         let pnetoTotal = 0
        let res =  this.DataCompletaAlmacen.filter(val => {
            return val.JORNADA == idproductophite;
        })

        res.forEach(element => {
          pnetoTotal += element.PESO_NETO_ALMCEN
        });

      return pnetoTotal.toFixed(3);

      },

      PnetoBalanzaJornada(idproductophite) {
         let pnetoTotal = 0
        let res =  this.DataCompleta.filter(val => {
            return val.JORNADA == idproductophite;
        })

        res.forEach(element => {
          pnetoTotal += element.PESO_NETO_PUERTO
        });

      return pnetoTotal.toFixed(3);

      },

     

      PnetoBalanza(row) {
      let pnetoTotal = 0
      let res =  this.DataCompleta.filter(val => {
      return val.ID_PRODUCTO == row;
      })

      res.forEach(element => {
      pnetoTotal += element.PESO_NETO_PUERTO
      });

      return pnetoTotal.toFixed(3);

      },
      
      convertir(item){
      if(typeof(item)==="string")
          return parseFloat(item.replace(",", "."))

      if (typeof(item)==="number")
          return parseFloat(item.toString())
 

            },

            getLista(){
        axios.get("https://gsx2json.aygajustadores.com/api?id=1t5QZ5dFrbaKWbYBG-bRH6t474z4fDoDjTsu5HX6ceWo&ID_NAVES="+this.ID_NAVE+"&columns=false&sheet=PRODUCTOS_NAVE" )
        .then(response => {this.listaDatos = response.data.rows.filter(consignatario => consignatario.ID_CONSIGNATARIO == this.ID_CONSIGNATARIO ) 
          
        })
        .catch(err=>{
          console.log(err);
            this.err = true;  
        })
        },

          getListaData(){
          axios.get("https://gsx2json.aygajustadores.com/api?id=1t5QZ5dFrbaKWbYBG-bRH6t474z4fDoDjTsu5HX6ceWo&ID_NAVE="+this.ID_NAVE+"&columns=false&sheet=DATA_GRANEL" )
          .then(response => {this.listaDatosData = response.data.rows.filter(consignatario => consignatario.ID_CONSIGNATARIO == this.ID_CONSIGNATARIO ) 
            
          })
          .catch(err=>{
            console.log(err);
              this.err = true;  
          })
          },

          getListaAlmacenes(){
          axios.get("https://gsx2json.aygajustadores.com/api?id=1t5QZ5dFrbaKWbYBG-bRH6t474z4fDoDjTsu5HX6ceWo&columns=false&sheet=LISTA_ALMACENES" )
          .then(response => {this.ListaAlmacenes = response.data.rows;
            
          })
          .catch(err=>{
            console.log(err);
              this.err = true;  
          })
          },
          

          getListaProducto(){
          axios.get("https://gsx2json.aygajustadores.com/api?id=1t5QZ5dFrbaKWbYBG-bRH6t474z4fDoDjTsu5HX6ceWo&columns=false&sheet=LISTA_PRODUCTOS" )
          .then(response => {this.listaDatosProducto = response.data.rows;
            
          })
          .catch(err=>{
            console.log(err);
              this.err = true;  
          })
          },
          GetListaConsginave(){
          axios.get("https://gsx2json.aygajustadores.com/api?id=1t5QZ5dFrbaKWbYBG-bRH6t474z4fDoDjTsu5HX6ceWo&columns=false&sheet=CONSIGNATARIO_NAVE" )
          .then(response => {this.listaConsignave = response.data.rows;
            
          })
          .catch(err=>{
            console.log(err);
              this.err = true;  
          })
          },
          GetListaClienteNave(){
          axios.get("https://gsx2json.aygajustadores.com/api?id=1t5QZ5dFrbaKWbYBG-bRH6t474z4fDoDjTsu5HX6ceWo&columns=false&sheet=CLIENTES_GRANEL" )
          .then(response => {this.listaClientesNave = response.data.rows;
            
          })
          .catch(err=>{
            console.log(err);
              this.err = true;  
          })
          },

          
                  getListaNave() {
          axios.get("https://gsx2json.aygajustadores.com/api?id=1Tpui79bHcuKUYPu_n7hdNQSUdphCjtmHTKW1_BCHelw&ID="+this.ID_NAVE+"&columns=false&sheet=NAVES" )
            .then((response) => {
              this.listaNaves = response.data.rows.filter(nave => {
                return Object.keys(nave).length > 0;
              });


              this.BuquesFechas = this.BuquesFechas(); // Actualiza BuquesFechas cuando se reciban los datos
            })
            .catch((err) => {
              console.log(err);
              this.err = true;
            });
        },


          getListaAlmacenesDistribucion(){
          axios.get("https://gsx2json.aygajustadores.com/api?id=1t5QZ5dFrbaKWbYBG-bRH6t474z4fDoDjTsu5HX6ceWo&ID_NAVES="+this.ID_NAVE+"&columns=false&sheet=DIST_PRODUCTOS_ALM" )
          .then(response =>  {this.listaDatosAlmacenDistribucion = response.data.rows.filter(consignatario => consignatario.ID_CONSIGNATARIO == this.ID_CONSIGNATARIO )
            
          })
          .catch(err=>{
            console.log(err);
              this.err = true;  
          })
          },

          GetListaJornada() {
        axios.get("https://gsx2json.aygajustadores.com/api?id=1t5QZ5dFrbaKWbYBG-bRH6t474z4fDoDjTsu5HX6ceWo&ID_NAVES="+this.ID_NAVE+"&columns=false&sheet=JORNADAS")
        .then(response => {
        // Filtra los elementos con propiedades específicas que no están vacías
        this.listaJornada = response.data.rows.filter(item => {
        // Ajusta las propiedades según tus necesidades
        return item.ID_NAVES !== undefined && item.ID_NAVES.trim() !== "";
        });
        })
        .catch(err => {
        console.log(err);
        this.err = true;
        });
},

          GetListaParalizacion() {
            axios.get("https://gsx2json.aygajustadores.com/api?id=1t5QZ5dFrbaKWbYBG-bRH6t474z4fDoDjTsu5HX6ceWo&ID_NAVE=" + this.ID_NAVE + "&columns=false&sheet=PARALIZACION")
              .then(response => {
                // Filtra los objetos no vacíos y con ID_CONSIGNATARIO igual a id_consignatario
                this.listaParalizacion = response.data.rows.filter(item => {
                  return Object.keys(item).length > 0 && item.ID_CONSIGNATARIO === this.ID_CONSIGNATARIO;
                });
              })
              .catch(err => {
                console.log(err);
                this.err = true;
              })
          },

          
       



    },

    watch: {
    listaJornada: {
      handler(newVal, oldVal) {
        if (newVal.length > 0 && this.listaDatosData.length > 0) {
          this.datosListos = true;
        }
      },
      deep: true
    },
    listaDatosData: {
      handler(newVal, oldVal) {
        if (newVal.length > 0 && this.listaJornada.length > 0) {
          this.datosListos = true;
        }
      },
      deep: true
    },
  },
    mounted() {
    this.cargarTodosLosDatos();

    }
  };
</script>

<style scoped>
.el-table .cell{
  padding-left: 0px  !important;
  padding-right: 0px  !important;
}
.chart-logo {
  width: 100px; /* Ajusta el tamaño según tus necesidades */
  display: block; /* Asegura que la imagen no tiene display:none */
  margin: 10px auto; /* Centra la imagen horizontalmente */
}

.btn-primary {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
  margin-bottom: 20px;
}

.text-center {
  text-align: center;
}
</style>
